import { MenuManager, Popup } from 'main.popup';
import { Dom, Text, Loc } from 'main.core';
import { BitrixVue } from 'ui.vue';
import { FileStatus } from 'ui.file-uploader.api';
import { UploadLoader } from './upload-loader';
import { TileUploader } from 'ui.file-uploader.widgets.tile-uploader';

export const TileItem = BitrixVue.localComponent('tile', {
	props: {
		item: {
			type: Object,
			default: {}
		},
	},
	components: {
		UploadLoader,
	},
	data() {
		return {
			tileId: 'tile-uploader-' + Text.getRandom().toLowerCase(),
			menu: null,
			errorPopup: null,
		};
	},
	methods: {
		remove(id)
		{
			const tileUploader: TileUploader = this.$Bitrix.Application.get();
			tileUploader.remove(id);
		},

		handleMouseEnter(item)
		{
			if (item.error)
			{
				if (!this.errorPopup)
				{
					this.errorPopup = new Popup({
						bindElement: this.$refs.container,
						darkMode: true,
						animation: 'fading-slide',
						width: 250,
						angle: { offset: 110 },
						offsetTop: 6,
						offsetLeft: -25,
						content: item.error.getMessage() + '<br>' + item.error.getDescription(),
					})
				}

				this.errorPopup.show();
			}
		},

		handleMouseLeave()
		{
			if (this.errorPopup)
			{
				this.errorPopup.destroy();
				this.errorPopup = null;
			}
		},

		showMenu(item)
		{
			if (this.menu)
			{
				this.menu.destroy();
			}

			this.menu = MenuManager.create({
				id: this.tileId,
				bindElement: this.$refs.menu,
				cacheable: false,
				items: [
					{ text: 'Download', href: item.downloadUrl }
				]
			});

			this.menu.show();
		},
	},
	computed: {
		FileStatus: () => FileStatus,
		status() {
			if (this.item.status === FileStatus.UPLOADING)
			{
				return this.item.progress + '%';
			}
			else if (this.item.status === FileStatus.LOAD_FAILED || this.item.status === FileStatus.UPLOAD_FAILED)
			{
				return Loc.getMessage('TILE_UPLOADER_ERROR_STATUS');
			}
			else
			{
				return Loc.getMessage('TILE_UPLOADER_WAITING_STATUS');
			}
		}
	},
	// language=Vue
	template: `
		<div
			class="ui-tile-uploader-item"
			:class="['ui-tile-uploader-item--' + item.status]"
			@mouseenter="handleMouseEnter(item)"
			@mouseleave="handleMouseLeave(item)"
			ref="container"
		>
			<div class="ui-tile-uploader-item-content">
				<div v-if="item.status !== FileStatus.COMPLETE" key="loader" class="ui-tile-uploader-item-state">
					<UploadLoader v-if="item.status === FileStatus.UPLOADING" :item="item"></UploadLoader>
					<div v-else class="ui-tile-uploader-item-state-icon"></div>

					<div class="ui-tile-uploader-item-status">{{status}}</div>
					<div class="ui-tile-uploader-item-state-desc">{{item.sizeFormatted}}</div>
					<div class="ui-tile-uploader-item-state-remove" @click="remove(item.id)"></div>
				</div>
				<div v-else key="complete" class="ui-tile-uploader-item-actions">
					<div class="ui-tile-uploader-item-remove" @click="remove(item.id)"></div>
					<div class="ui-tile-uploader-item-menu" @click="showMenu(item)" ref="menu"></div>
				</div>
				<div class="ui-tile-uploader-item-preview">
					<template v-if="item.isImage">
						<div
							class="ui-tile-uploader-item-image"
							:class="{ 'ui-tile-uploader-item-image-default': item.previewUrl === null }"
							:style="{ backgroundImage: item.previewUrl !== null ? 'url(' + item.previewUrl + ')' : '' }">
						</div>
						<div class="ui-tile-uploader-item-image-name" :title="item.originalName">{{item.originalName}}</div>
					</template>
					<div v-else class="ui-tile-uploader-item-file"></div>
				</div>
			</div>
		</div>
	`
	/*template: `
		<div class="disk-file-thumb" :class="[
			item.isImage ? 'disk-file-thumb-preview' : 'disk-file-thumb-file',
			item.status === 'uploading' ? 'disk-file-thumb--active' : '',
			'disk-file-thumb--' + item.status
		]">
			<template v-if="item.isImage && item.previewUrl !== null">
				<div
					class="disk-file-thumb-image" style="background-size: cover"
					:style="{ backgroundImage: 'url(' + item.previewUrl + ')' }">
				</div>
			</template>
			<div class="disk-file-thumb-loader" ref="loader">
				<div class="disk-file-thumb-loader-size">{{item.sizeFormatted}}</div>
			</div>

			<div class="ui-icon disk-file-thumb-icon" :class="'ui-icon-file-'+ item.extension"><i></i></div>

			<div class="disk-file-thumb-text">{{item.originalName}}</div>

			<div class="disk-file-thumb-btn-box">
				<div class="disk-file-thumb-btn-close" @click="remove(item.id)"></div>
				<div class="disk-file-thumb-btn-more" @click="showMenu(item)" ref="menu"></div>
			</div>
		</div>
	`*/
});
